export default __webpack_public_path__ + "static/media/location@3x.431c51da.png";